"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var app_1 = require("../app");
var useContext = React.useContext;
exports.default = (function (_a) {
    var skipSteps = _a.skipSteps, titles = _a.titles;
    var context = useContext(app_1.AppContext);
    if (!context) {
        return null;
    }
    var allBundlerSteps = context.allBundlerSteps, bundlerSteps = context.bundlerSteps, currentStepIdx = context.currentStepIdx;
    var numOutputtedSteps = -1;
    return (React.createElement("div", { className: 'grid-x text-center bundler-app-progress show-for-medium padding-vertical-4 large-padding-horizontal-8' }, allBundlerSteps.map(function (step, i) {
        if (skipSteps && skipSteps.includes(step)) {
            return null;
        }
        numOutputtedSteps++;
        var currentIdx = bundlerSteps.indexOf(step);
        var isHighlighted = currentIdx <= currentStepIdx;
        return (React.createElement(React.Fragment, { key: step },
            numOutputtedSteps > 0 && React.createElement("div", { className: (0, classnames_1.default)('cell shrink divider', isHighlighted && 'highlighted') }, "\u00A0"),
            React.createElement("div", { className: (0, classnames_1.default)('auto cell step', isHighlighted && 'highlighted') },
                React.createElement("div", { className: 'step-circle flex-container align-center align-middle margin-bottom-2' }, numOutputtedSteps + 1),
                React.createElement("div", { className: 'step-name' },
                    React.createElement("div", { className: 'hide-for-medium' }, titles[i][0]),
                    React.createElement("div", { className: 'show-for-medium' }, titles[i][1])))));
    })));
});
